export const dependantsQuestions: Record<string, any> = {
  dependantsUnder13: {
    labelKey: 'applicationForm.DEPENDANTS.dependantsUnder13.label',
    explanationKey: 'applicationForm.DEPENDANTS.dependantsUnder13.explanation',
  },
  dependantsOver13: {
    labelKey: 'applicationForm.DEPENDANTS.dependantsOver13.label',
    explanationKey: 'applicationForm.DEPENDANTS.dependantsOver13.explanation',
  },
};
